import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/menu/combos", label: "Combo Meals" },
  { to: "/menu/a-la-carte", label: "À La Carte" },
];

// Simple, clear sub-menu switcher shown on both menu pages.
export default function MenuTabs() {
  return (
    <div className="bg-[#0a0a0a] border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-6">
        <div data-testid="menu-tabs" className="flex justify-center gap-3">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`tab-${t.to.split("/").pop()}`}
              className={({ isActive }) =>
                `rounded-full px-6 py-3 text-base md:text-lg font-semibold transition-colors border-2 ${
                  isActive
                    ? "bg-[#ffd100] text-[#0a0a0a] border-[#ffd100]"
                    : "bg-transparent text-[#ffd100] border-[#ffd100]/50 hover:bg-[#ffd100] hover:text-[#0a0a0a]"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
